// 自定义下拉框功能
class CustomSelect {
  constructor(selectElement) {
    this.selectElement = selectElement;
    this.selectWrapper = selectElement.closest('.select');
    this.init();
  }

  init() {
    this.createCustomSelect();
    this.bindEvents();
  }

  createCustomSelect() {
    // 获取原生select的选项
    const options = Array.from(this.selectElement.options);
    const selectedOption = options.find(option => option.selected) || options[0];

    // 创建自定义选择器结构
    const customHeader = document.createElement('div');
    customHeader.className = 'custom-select-header';
    customHeader.innerHTML = `
      <span class="custom-select-text">${selectedOption.text}</span>
    `;

    const customOptions = document.createElement('div');
    customOptions.className = 'custom-select-options';

    // 创建选项
    options.forEach(option => {
      if (option.value !== '' && option.text.trim() !== '') {
        const customOption = document.createElement('button');
        customOption.className = 'custom-select-option';
        customOption.textContent = option.text;
        customOption.setAttribute('data-value', option.value);
        
        if (option.selected) {
          customOption.classList.add('selected');
        }
        
        customOptions.appendChild(customOption);
      }
    });

    // 插入到DOM中
    this.selectWrapper.appendChild(customHeader);
    this.selectWrapper.appendChild(customOptions);

    // 保存引用
    this.customHeader = customHeader;
    this.customOptions = customOptions;
    this.customText = customHeader.querySelector('.custom-select-text');
  }

  bindEvents() {
    // 点击头部切换下拉框
    this.customHeader.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.toggle();
    });

    // 点击选项
    this.customOptions.addEventListener('click', (e) => {
      if (e.target.classList.contains('custom-select-option')) {
        e.preventDefault();
        e.stopPropagation();
        this.selectOption(e.target);
      }
    });

    // 点击外部关闭
    document.addEventListener('click', (e) => {
      if (!this.selectWrapper.contains(e.target)) {
        this.close();
      }
    });

    // 键盘支持
    this.customHeader.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.toggle();
      } else if (e.key === 'Escape') {
        this.close();
      }
    });

    // 选项键盘导航
    this.customOptions.addEventListener('keydown', (e) => {
      const currentOption = document.activeElement;
      let nextOption = null;

      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          nextOption = currentOption.nextElementSibling || this.customOptions.firstElementChild;
          break;
        case 'ArrowUp':
          e.preventDefault();
          nextOption = currentOption.previousElementSibling || this.customOptions.lastElementChild;
          break;
        case 'Enter':
          e.preventDefault();
          this.selectOption(currentOption);
          break;
        case 'Escape':
          e.preventDefault();
          this.close();
          this.customHeader.focus();
          break;
      }

      if (nextOption) {
        nextOption.focus();
      }
    });

    // 设置可访问性属性
    this.customHeader.setAttribute('tabindex', '0');
    this.customHeader.setAttribute('role', 'combobox');
    this.customHeader.setAttribute('aria-expanded', 'false');
    this.customOptions.setAttribute('role', 'listbox');
    
    const options = this.customOptions.querySelectorAll('.custom-select-option');
    options.forEach((option, index) => {
      option.setAttribute('role', 'option');
      option.setAttribute('tabindex', '-1');
      option.setAttribute('id', `custom-option-${index}`);
    });
  }

  toggle() {
    if (this.selectWrapper.classList.contains('active')) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    // 关闭其他打开的下拉框
    document.querySelectorAll('.select.active').forEach(select => {
      select.classList.remove('active');
      const options = select.querySelector('.custom-select-options');
      if (options) options.classList.remove('active');
    });

    this.selectWrapper.classList.add('active');
    this.customOptions.classList.add('active');
    this.customHeader.setAttribute('aria-expanded', 'true');

    // 聚焦到选中的选项
    const selectedOption = this.customOptions.querySelector('.custom-select-option.selected');
    if (selectedOption) {
      setTimeout(() => selectedOption.focus(), 100);
    }
  }

  close() {
    this.selectWrapper.classList.remove('active');
    this.customOptions.classList.remove('active');
    this.customHeader.setAttribute('aria-expanded', 'false');
  }

  selectOption(optionElement) {
    const value = optionElement.getAttribute('data-value');
    const text = optionElement.textContent;

    // 更新原生select
    this.selectElement.value = value;
    
    // 触发change事件
    const changeEvent = new Event('change', { bubbles: true });
    this.selectElement.dispatchEvent(changeEvent);

    // 更新UI
    this.customText.textContent = text;
    
    // 更新选中状态
    this.customOptions.querySelectorAll('.custom-select-option').forEach(option => {
      option.classList.remove('selected');
    });
    optionElement.classList.add('selected');

    // 关闭下拉框
    this.close();

    // 提交表单（如果需要）
    const form = this.selectElement.closest('form');
    if (form) {
      form.submit();
    }
  }
}

// 初始化所有自定义下拉框
document.addEventListener('DOMContentLoaded', function() {
  initCustomSelects();
});

// 也监听动态加载的内容
document.addEventListener('shopify:section:load', function() {
  initCustomSelects();
});

function initCustomSelects() {
  const selectElements = document.querySelectorAll('.facet-filters.sorting.caption .select__select');
  
  selectElements.forEach(selectElement => {
    // 检查是否已经初始化过
    if (!selectElement.closest('.select').querySelector('.custom-select-header')) {
      new CustomSelect(selectElement);
    }
  });
}

// 导出供其他脚本使用
window.CustomSelect = CustomSelect;

